import "./distance_select.css";
import React, { useEffect } from "react";
import { isMobile } from "../../../App";

interface DistanceSelectProps {
  distances: any;
  activeDistance?: any;
  changeActiveDistance: (tab: any) => void;
}

const DistanceSelect: React.FC<DistanceSelectProps> = ({ distances, activeDistance, changeActiveDistance }) => {
  const handleSelect = (tab: any) => {
    changeActiveDistance(tab);
  };

  return (
    <div className="distances-mobile">
      <label>MESAFE : </label>
      <select
        style={{ fontSize: !isMobile ? "12px" : "10px", paddingInline: !isMobile ? "20px" : "5px" }}
        value={activeDistance || 0}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => changeActiveDistance(e.target.value)}
      >
        {distances && distances.length > 0 ? (
          distances.map((distance: string, index: number) => (
            <option key={`distance-${index}`} value={distance}>
              {distance}
            </option>
          ))
        ) : (
          <option>-</option>
        )}
      </select>
    </div>
  );

  return (
    <div className="distances">
      <label>MESAFE : </label>
      {distances && distances.length > 0 ? (
        distances.map((distance: any) => (
          <div className="distance-item" key={distance}>
            <a
              className={`distance-link ${activeDistance === distance ? "active" : ""}`}
              onClick={() => handleSelect(distance)}
              href="#!"
            >
              {distance}
            </a>
          </div>
        ))
      ) : (
        <div className="distance-item">
          <a className={`distance-link`} href="#!">
            -
          </a>
        </div>
      )}
    </div>
  );
};

export default DistanceSelect;
